const TABLET_BREAKPOINT = 768;
const SEARCH_CACHE_DAYS = 5;
const ORIGIN_DIRECTION = 'origin';
const DESTINATION_DIRECTION = 'destination';
const ONE_WAY_SEARCH = 'one-way';
const ROUND_TRIP_SEARCH = 'round-trip';
const SEARCH_TYPES = [ONE_WAY_SEARCH, ROUND_TRIP_SEARCH];

export {
    DESTINATION_DIRECTION,
    ONE_WAY_SEARCH,
    ORIGIN_DIRECTION,
    ROUND_TRIP_SEARCH,
    SEARCH_CACHE_DAYS,
    SEARCH_TYPES,
    TABLET_BREAKPOINT,
};
